import React from 'react';

interface SpaceProps {
    h?: number | string;
    w?: number| string;
}

const Space: React.FC<SpaceProps> = ({h = 0, w = 0}) => {
    return <div style={{height: h, width: w}}/>;
};

export default Space;

export const spaceSizes = {
    s4: 4,
    s6: 6,
    s8: 8,
    s10: 10,
    s12: 12,
    s14: 14,
    s16: 16,
    s20: 20,
    s28: 28,
    s50: 50,
    infinity: '100%'
}